import React, { useState, useEffect } from 'react';
import useDynamicMeta from '../hooks/useDynamicMeta';
import ApexNavbar from './ApexNavbar';
import ApexTop from './ApexTop';
import ApexFeatures from './ApexFeatures';
import ApexInfoBlocks from './ApexInfoBlocks';
import ApexPricing from './ApexPricing';
import ApexFooter from './ApexFooter';
import ApexToS from './ApexToS';
import './ApexApp.css';

// Gibt für jede Hash-Route Titel, Description und Social‑Image zurück
function getMetaForHash(hash) {
  switch (hash) {
    case '#Tos':
      return {
        title: 'EAGLE SCRIPT - Terms of Service',
        description: 'Terms of Service for EAGLE SCRIPT Apex services and products.',
        image: window.location.origin + '/social-preview.png',
      };
    default:
      return {
        title: 'Apex Script | Undetected Apex No Recoil Script',
        description:
          'Boost your Apex Legends gameplay with EAGLE SCRIPT – the undetected no‑recoil solution: 100% secure, fully customizable, cloud hotkeys, frequent updates & 24/7 Discord support.',
        image: window.location.origin + '/social-preview.png',
      };
  }
}

function ApexApp() {
  const [hash, setHash] = useState(window.location.hash || '');

  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    
    // Füge apex-page Klasse zum html Element hinzu
    document.documentElement.classList.add('apex-page');
    
    // Ändere Favicon zu Apex-Version
    const changeFavicon = (href) => {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = href;
      document.getElementsByTagName('head')[0].appendChild(link);
    };
    
    changeFavicon('/favicon_apex.ico');
    
    return () => {
      window.removeEventListener('hashchange', onHashChange);
      // Entferne apex-page Klasse beim Unmounting
      document.documentElement.classList.remove('apex-page');
      // Setze Standard-Favicon zurück
      changeFavicon('/favicon.ico');
    };
  }, []);

  const { title, description, image } = getMetaForHash(hash);
  const canonicalUrl =
    window.location.origin + window.location.pathname + (hash || '');
  useDynamicMeta({ title, description, canonicalUrl, image });

  return (
    <div className="apex-app">
      {hash !== '#Tos' && <ApexNavbar />}

      {hash === '#Tos' ? (
        <ApexToS />
      ) : (
        <>
          <div className="top-wrapper">
            <div className="top-shadow" />
            <ApexTop />
          </div>
          <ApexFeatures />
          <ApexInfoBlocks />
          <ApexPricing />
        </>
      )}

      {hash !== '#Tos' && <ApexFooter />}
    </div>
  );
}

export default ApexApp;